interface IPathArrowSVGProps {
  className?: string;
}

/**
 * -----------------------------------------------------------------------------
 * The svg component is used to render illustration as svg in dom,
 * This svg component will use in feedback view.
 */
export function PathArrowSVG({ className }: IPathArrowSVGProps) {
  return (
    <svg className={className} id="arrow-short" viewBox="0 0 150 250">
      <g id="arrow-short">
        <path
          className="fill-none stroke-green-800 stroke-2"
          d="M27.1,6C13.26,27.78,5.4,52.27,4.17,77.4c-1.23,25.13,4.22,50.16,15.88,72.97,11.66,22.81,29.19,42.74,51.12,58.09,21.92,15.36,47.59,25.69,74.83,30.13"
          id="body"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ strokeDasharray: '10 10' }}
        />
        <path
          className="fill-green-800 stroke-1"
          d="M136.87,229.31c-.21-.18-.52-.16-.71.05-.18.21-.16.52.05.71l9.78,8.54-11.65,4.62c-.26.1-.38.39-.28.65.1.26.39.38.65.28l11.65-4.62c.32-.13.56-.42.62-.76.06-.34-.07-.69-.33-.92l-9.78-8.54"
          id="head"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
